export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/background-17dab84292379db3ffbf0f4da509d319.svg";